export default __webpack_public_path__ + "static/media/edit.84a7c8ba.svg";